import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import HRReport from '../components/HRReport/HRReport.jsx';

export default function HRReportPage() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        HR Report
      </Typography>
      <HRReport />
    </Box>
  );
}
